import { useState } from 'react'

import { Salary } from 'InstitutionalManagement/types'
import getSalaryOnCustomForm from './services/getSalaryOnCustomForm'

export default function useGetSalaryByID() {
  const [loadingSalary, setLoadingSalary] = useState<boolean>(false)
  const [salary, setSalary] = useState<Salary>({})

  async function getSalary(salaryId?: string) {
    setLoadingSalary(true)
    const response = await getSalaryOnCustomForm({ salaryId: salaryId as string })
    let salaryFromAPI: Salary = {}
    if (response?.header?.success) {
      salaryFromAPI = response?.body?.salary
      setSalary(salaryFromAPI)
    }
    setLoadingSalary(false)
    return salaryFromAPI
  }

  return { getSalary, salary, loadingSalary }
}
